import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader, EmptyState, StatusBadge, Money } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { ClipboardList, CreditCard } from "lucide-react";

export default function Orders() {
  const [orders, setOrders] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/retailer/orders").then((r) => setOrders(r.data)).catch(() => setOrders([])); }, []);
  if (!orders) return <Loader />;
  if (!orders.length) return <EmptyState title="No orders yet." hint="Once you place an order it will appear here." icon={ClipboardList}
    action={<Button className="bg-forest text-white hover:bg-forest/90" onClick={() => nav("/retailer/marketplace")}>Start shopping</Button>} />;

  return (
    <div className="space-y-4">
      <h1 className="font-heading text-2xl font-semibold text-forest">My Orders</h1>
      {orders.map((o) => (
        <div key={o.id} data-testid={`order-row-${o.id}`} className="rounded-xl border border-border bg-card p-4">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <div>
              <p className="num text-sm font-semibold text-forest">{o.order_number}</p>
              <p className="text-xs text-ink/50">{o.manufacturer_name} · {o.items.length} item(s) · {o.created_at.slice(0, 10)}</p>
            </div>
            <div className="flex items-center gap-2">
              <StatusBadge status={o.status} />
              <Money value={o.total} className="text-forest" />
            </div>
          </div>
          <div className="mt-3 flex gap-2">
            <Button data-testid={`order-view-${o.id}`} variant="outline" size="sm" className="border-forest text-forest hover:bg-psage" onClick={() => nav(`/retailer/orders/${o.id}`)}>View / Track</Button>
            {o.status === "AWAITING_PAYMENT" && (
              <Button data-testid={`order-pay-${o.id}`} size="sm" className="bg-forest text-white hover:bg-forest/90"
                onClick={() => nav("/retailer/checkout", { state: { orders: [{ order_id: o.id, order_number: o.order_number, total: o.total }] } })}>
                <CreditCard className="mr-1.5 h-3.5 w-3.5" /> Pay now
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
